import { useCallback } from 'react'

import { KEYBOARD_EVENTS } from '@/pages/benefits/events/constants'

const useKeyboardInteraction = (onActivate) => {
  const handleKeyDown = useCallback(
    (e) => {
      const { key, currentTarget } = e

      if (key === KEYBOARD_EVENTS.ENTER || key === KEYBOARD_EVENTS.SPACE) {
        e.preventDefault()

        if (onActivate && typeof onActivate === 'function') {
          onActivate(e)
        } else {
          currentTarget.focus()
        }
      }
    },
    [onActivate]
  )

  return { handleKeyDown }
}

export default useKeyboardInteraction
